<script lang="ts">
  import { get } from "svelte/store";
  import { Card, Badge, Button } from "flowbite-svelte";
  import { navigateTo } from "../../services/routing/route-action.js";
  import { type Customer } from "../../services/api/types.js";
  import { editObject, drawerStore } from "../../services/stores/object-drawer-store.js";
  import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
  import { faPencil, faEye } from "@fortawesome/free-solid-svg-icons";
  import { userStore } from "../../services/stores/user-store.js";

  export let customer: Customer;

  let canManageCustomers = false;
  let canViewResults = false;
  const store = get(userStore);
  canManageCustomers = store.claims?.canManageCustomers ?? false;
  canViewResults = store.claims?.canViewResults ?? false;

  $: {
    if (
      $drawerStore.objectType === "customer" &&
      $drawerStore.object?.customer_id === customer.customer_id
    ) {
      customer = $drawerStore.object;
    }
  }

  function onEditClick() {
    editObject("customer", customer.customer_id);
  }

  function onViewResults() {
    navigateTo(`view-results?id=${customer.customer_id}`);
  }
</script>

<Card class="app-card-area max-w-sm h-full">
  <div class="flex items-center justify-left mb-4">
    <h3 class="text-base font-bold">Customer</h3>
    {#if canManageCustomers}
      <Button
        pill={true}
        outline={true}
        class="general-button icon-only borderless ml-2"
        size="sm"
        on:click={onEditClick}
        >
        <FontAwesomeIcon icon={faPencil} />
      </Button>
    {/if}
    {#if canViewResults && customer.projects_with_results > 0}
      <Button
        pill={true}
        outline={true}
        class="grid-header-button with-text"
        size="sm"

        on:click={onViewResults}
      >
        <FontAwesomeIcon icon={faEye} /> View
      </Button>
    {/if}
  </div>
  <div class="space-y-4">
    <div>
      <h4 class="card-label-text">Name</h4>
      <p class="card-text">{customer.name}</p>
    </div>
    {#if customer.metadata}
      {#each Object.entries(customer.metadata) as [field, value]}
        <div>
          <h4 class="card-label-text">
            {field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
          </h4>
          {#if Array.isArray(value)}
            {#each value as item}
              <p class="card-text">{item.name}</p>
            {/each}
          {:else if value && typeof value === "object"}
            <p class="card-text">{value.name}</p>
          {:else}
            <p class="card-text">{value}</p>
          {/if}
        </div>
      {/each}
    {/if}
  </div>
</Card>

<style>
  :global(.card) {
    border-radius: 0;
    box-shadow: none;
    border: 1px solid #e5e7eb;
  }
</style>
